import { ObservabilityToolType } from 'types/api/status-checks/status-check'
import { OBSERVABILITY_TOOL_DISPLAY_NAME } from 'utils/status-checks/status-checks-utils'

export type ThirdPartyExternalIntegration = Extract<
  ObservabilityToolType,
  | ObservabilityToolType.AWS
  | ObservabilityToolType.AZURE
  | ObservabilityToolType.GCP
>

export const ORDERED_THIRD_PARTY_TYPES = [
  ObservabilityToolType.AWS,
  ObservabilityToolType.AZURE,
  ObservabilityToolType.GCP
] as const

export const THIRD_PARTY_SELECT_OPTIONS = ORDERED_THIRD_PARTY_TYPES.map(
  (type) => {
    const label = OBSERVABILITY_TOOL_DISPLAY_NAME[type]
    return { label, value: type }
  }
)
